module.exports = __webpack_public_path__ + "static/img/border2.f4bca396.png";